export default __webpack_public_path__ + "static/media/TMDBLogoDark.0c637090.svg";